export const ANAC_AERODROMOS_PUBLICOS_CSV_URL =
  'https://www.anac.gov.br/acesso-a-informacao/dados-abertos/areas-de-atuacao/aerodromos/lista-de-aerodromos-publicos/aerodromospublicosv1.csv/@@download/file/aerodromospublicosv1.csv';

export const AEROPORTOS_GOLDEN_IATA_GRU = 'GRU';
export const AEROPORTOS_GOLDEN_IATA_GIG = 'GIG';
export const AEROPORTOS_GOLDEN_IATA_BSB = 'BSB';
export const AEROPORTOS_GOLDEN_IATA_SSA = 'SSA';
export const AEROPORTOS_GOLDEN_IATA_CGB = 'CGB';

export const AEROPORTOS_GOLDEN_ICAO_GRU = 'SBGR';
export const AEROPORTOS_GOLDEN_ICAO_GIG = 'SBGL';
export const AEROPORTOS_GOLDEN_ICAO_BSB = 'SBBR';
export const AEROPORTOS_GOLDEN_ICAO_SSA = 'SBSV';
export const AEROPORTOS_GOLDEN_ICAO_CGB = 'SBCY';

export const AEROPORTOS_MIN_AERODROMOS = 400;
export const AEROPORTOS_MAX_AERODROMOS = 600;
export const AEROPORTOS_MIN_WITH_IATA = 50;
